import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const userRoutes = {
  name: 'profile',
  path: 'user/profile',
  component: () => import('./User.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
